import ListActions from "modules/list/actions";

import { DaemonSetSchema } from "utils/schemas";

export const DAEMONSETS_MODULE = "clusterGroupDaemonSets";

export const daemonSetsListingActions = new ListActions({
  async fetchData({ namespaces = [], clusters = [] } = {}) {
    //TODO
    return {
      items: [],
    };
  },
  initialQuery: () => ({
    namespaces: [],
    clusters: [],
  }),
  schema: [DaemonSetSchema],
});
